import React, { useState } from "react"
import { Icon } from "frontend/components/icons"
import styles from "./IconWithExplanation.module.css"
import { handleClickViaKeyboard } from "frontend/utils/a11y"
import { t } from "frontend/utils"

const IconWithExplanation = ({ icon, explanation, className }) => {
  const [showExplanation, setShowExplanation] = useState(false)

  const toggleExplanation = (e) => {
    setShowExplanation(!showExplanation)
  }
  return (
    <div
      className={styles.container}
      onMouseEnter={() => setShowExplanation(true)}
      onMouseLeave={() => setShowExplanation(false)}
    >
      <Icon
        name={icon}
        ariaLabel={t("form.explanation")}
        className={className}
        onClick={toggleExplanation}
        onKeyPress={handleClickViaKeyboard(toggleExplanation)}
      />
      {showExplanation && (
        <div className={styles.explanation}>
          <span className={styles.arrow} />
          {explanation}
        </div>
      )}
    </div>
  )
}

export default IconWithExplanation
